import { useEffect, useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import PlayerPicker, { PlayerChips } from "./PlayerPicker";
import { errMsg, inputCls } from "@/lib/scoring";

export default function Groups({ api }) {
  const [groups, setGroups] = useState([]);
  const [edit, setEdit] = useState(null);
  const [err, setErr] = useState("");
  const load = () => api.get("/scoring/groups").then((d) => setGroups(d.groups));
  useEffect(() => { load(); }, [api]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    setErr("");
    try { await api.post("/scoring/groups", { id: edit.id, name: edit.name, player_ids: edit.players.map((p) => p.id) }); setEdit(null); load(); } catch (e) { setErr(errMsg(e)); }
  };
  const remove = async (g) => { if (window.confirm(`Delete the group "${g.name}"? Scores are kept.`)) { await api.del(`/scoring/groups/${g.id}`); load(); } };
  return (
    <div data-testid="groups">
      {!edit && <button data-testid="new-group-btn" onClick={() => setEdit({ name: "", players: [] })} className="rounded-full bg-[#2563EB] hover:bg-[#1d4fd7] px-5 py-2.5 text-sm font-bold text-white transition-colors">New group</button>}
      {edit && (
        <div data-testid="group-editor" className="rounded-2xl bg-white border border-slate-200 p-5 space-y-4">
          <input data-testid="group-name" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} placeholder="Group name, e.g. Tuesday 13U hitters" className={inputCls} />
          <PlayerPicker api={api} exclude={edit.players.map((p) => p.id)} onPick={(p) => setEdit((x) => ({ ...x, players: [...x.players, p] }))} />
          <PlayerChips players={edit.players} onRemove={(id) => setEdit((x) => ({ ...x, players: x.players.filter((p) => p.id !== id) }))} />
          {err && <p data-testid="group-error" className="text-sm font-semibold text-red-600">{err}</p>}
          <div className="flex gap-3"><button data-testid="save-group-btn" onClick={save} className="rounded-full bg-[#2563EB] px-5 py-2.5 text-sm font-bold text-white">Save group</button><button onClick={() => setEdit(null)} className="rounded-full border border-slate-300 px-5 py-2.5 text-sm font-bold text-slate-600">Cancel</button></div>
        </div>
      )}
      <div className="mt-5 space-y-3">
        {!groups.length && <p className="text-sm text-slate-400">No saved groups yet.</p>}
        {groups.map((g) => (
          <div key={g.id} data-testid={`group-${g.id}`} className="rounded-2xl bg-white border border-slate-200 p-4">
            <div className="flex items-center justify-between gap-3"><p className="font-bold text-[#0B0F19]">{g.name} <span className="text-slate-400 font-medium text-sm">· {g.players.length} players</span></p>
              <span className="flex gap-3"><button data-testid={`edit-group-${g.id}`} onClick={() => setEdit({ id: g.id, name: g.name, players: g.players })} className="text-slate-500 hover:text-[#0B0F19]"><Pencil size={15} /></button><button data-testid={`delete-group-${g.id}`} onClick={() => remove(g)} className="text-slate-500 hover:text-red-600"><Trash2 size={15} /></button></span></div>
            <div className="mt-3"><PlayerChips players={g.players} testid={`group-players-${g.id}`} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
